import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./dashBoardStyles.module.css";

const Notifications = () => {
  const data = useSelector((state) => state.dashboard.data);
  return (
    <section className={styles.notificationList}>
      <h1>Notification List</h1>
      <div className={styles.notificationListDiv}>
        {data.notifications.map((notification, index) => {
          return (
            <div className={styles.notificationDiv} key={index}>
              <div className={styles.notificationImgDiv}>
                <img className={styles.notificationImg} src={notification.pic} alt="notification"></img>
              </div>
              <div className={styles.notificationTextDiv}>
                <p className={styles.notificationText}>
                  {notification.message
                    .split(" ")
                    .slice(0, notification.message.length - 2)
                    .join(" ")}
                  <Link to="/dashboard">
                    {notification.message
                      .split(" ")
                      .slice(notification.message.length - 2)
                      .join(" ")}
                  </Link>
                </p>
                <p className={styles.notificationTime}>{notification.time}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Notifications;
